import { insuranceLogosColor } from '@/domain/useCases/insurance/insuranceLogosColor'
import getCloudinaryUrl from '@/utils/getCloudinaryUrl'
import { isNonEmptyString } from './checks'
export const getColorInsuranceLogo = (k: string) => {
  if (!isNonEmptyString(k)) return null
  return insuranceLogosColor[k]
    ? insuranceLogosColor[k]
    : getCloudinaryUrl(`/icons/insurance/${k}`, 'g_auto')
}
